import { CountryCode, parsePhoneNumberWithError } from 'libphonenumber-js'

/**
 * Returns the country code (e.g., "FR", "US") from a phone number.
 * @param phoneNumber A string with the phone number in international format (e.g., "+33612345678")
 * @returns ISO country code or undefined if invalid
 */
export function getCountryCodeFromPhoneNumber(phoneNumber: string): CountryCode | undefined {
  try {
    const parsed = parsePhoneNumberWithError(phoneNumber)
    return parsed.country
  } catch {
    return undefined
  }
}
